import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { forgetUserName } from './forgetUserName'
import { UnoCaptcha } from 'uno-security-common'

const unoCaptcha = UnoCaptcha.reducer;

const mainReducer = combineReducers({
    form: formReducer,
    forgetUserName,
    unoCaptcha
});

export default mainReducer;